import compileInvalidFormField from '../util/invalid_form_field'

const selector = ['input', 'textarea', 'select']
  .map(tagName => `${tagName}.is-invalid`)
  .join(', ')

up.compiler(selector, compileInvalidFormField)
